export default "__VITE_ASSET__DCVA5pnA__"